import AxiosClient from "../../services/axios.services";

class NotificationsServices {
  getNotifications = params =>
    AxiosClient.get("/api/app/notificacion_aurora/", {
      headers: { "Content-Type": "application/json" },
      params: params,
   });  
  notificacionRead = (id, data) =>
    AxiosClient.put(`/api/app/notificacion_aurora/${id}/`, data , {
      headers: { "Content-Type": "application/json" },
    
    });
  saveNotifications = data =>
    AxiosClient.post("/api/app/notificacion_aurora/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editNotifications = (id, data) =>
    AxiosClient.put(
      `/api/app/notificacion_aurora/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteNotifications = id =>
    AxiosClient.delete(`/api/app/notificacion_aurora/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new NotificationsServices();